import { faEdit } from '~components/icon';
import { Column } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';

const columnsFactory = (toggleSahBudgetsModal: (id: number) => void) => {
  const columns: Column[] = [
    {
      id: 'client',
      header: 'Client',
      type: 'text',
      deriveValue: (row) => row?.client?.full_name || '',
      renderReadOnly: linkCellRender((row) => toggleSahBudgetsModal(row.client_id), faEdit),
    },
    {
      id: 'sah_budget_id',
      header: 'Budget ID',
      type: 'text',
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'text',
    },
  ];

  return columns;
};

export default columnsFactory;
